import NitroService from "./nitro.service";
import ILocation from "../types/ILocation";
import { IStationRow } from "../types/IRailFreightDetails";

export interface RailStationPayloadEntry {
  scrsId?: string;
  stationState: string;
  carriers: string[];
}

interface ExistingRailStation {
  scrsId?: string;
  stationState: string;
  carriers: { id: string }[];
}

const toRailStationPayloadEntry = (
  station: ExistingRailStation,
): RailStationPayloadEntry => ({
  scrsId: station.scrsId,
  stationState: station.stationState,
  carriers: station.carriers.map((carrier) => carrier.id),
});

export const mergeRailStationEntry = (
  existingStations: ExistingRailStation[] | undefined,
  updatedEntry: RailStationPayloadEntry,
): RailStationPayloadEntry[] => {
  const merged = (existingStations || []).map(toRailStationPayloadEntry);
  const existingIndex = merged.findIndex(
    (station) => station.stationState === updatedEntry.stationState,
  );
  if (existingIndex >= 0) {
    merged[existingIndex] = updatedEntry;
  } else {
    merged.push(updatedEntry);
  }
  return merged;
};

export interface SaveLocationModesParams {
  id: string;
  modes: { id: string; inbound: boolean; outbound: boolean }[];
  threeLegsAllowed: boolean;
  equipmentTypes: string[];
  railStations: IStationRow[];
}

export const saveLocationModes = async ({
  id,
  modes,
  threeLegsAllowed,
  equipmentTypes,
  railStations,
}: SaveLocationModesParams): Promise<void> => {
    await NitroService.updateLocationModes2({
      id,
      modes,
      threeLegsAllowed,
      equipmentTypes,
      railStations,
    });
};

export const fetchUpdatedLocation = async (
  id: string
): Promise<ILocation | undefined> => {
  const results = await NitroService.getMultiLocationDetails2({ ids: [id] });
  return results?.[0];
};

export const findRailStation = (
  location: ILocation | undefined,
  stationState: string,
) =>
  location?.railStations?.find(
    (station) => station.stationState === stationState,
  );
